import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import UnSubscribeForm from './Components/UnSubscribeForm/UnSubscribeForm';
import UnsubscribeConfirmation from './Components/UnSubscribeConfirmation/UnsubscribeConfirmation';
import AdminPortal from './Components/AdminPortal/AdminPortal';

function AppRouter() {
  return (
    <Router>
      <Route path="/" exact component={UnSubscribeForm} />
      <Route path="/confirm" component={UnsubscribeConfirmation} />
      <Route path="/admin" component={AdminPortal} />
    </Router>

  );
}
export default AppRouter;
